import { apiClient } from '../client';
import { API_ENDPOINTS } from '../constant/endpoints';
import type { IApiResponse } from '../types';
import type { IPermissionCatalogEntry } from '@/features/users-roles/interfaces';

export const permissionsApi = {
    list: () =>
        apiClient
            .get<IApiResponse<IPermissionCatalogEntry[]>>(API_ENDPOINTS.PERMISSION.LIST)
            .then((r) => r.data.data),
};
